export default function DisclaimerText({ content }: { content: string }) {
  return (
    <div className="max-w-[1090px] p-[20px] mb-[40px] border border-[#F4B233] rounded-[10px] bg-[#FEFBF4]">
      <h2 className="text-[18px] font-MetropolisMedium pb-[5px]">Application in progress</h2>
      <p className="text-[12px] sm:text-[14px] leading-[20px] font-sans text-[#4A4F55]">{content}</p>
    </div>
  );
}
